<template>
  <div>
    <div class="notify-left">
      <img src="https://assets.sororitywars.app/icons/notify/V2/house.png" width="40" height="40" class="desktop-notify-image" alt="" />
    </div>
    <div class="notify-right">
      <button type="button" class="notify-close" aria-label="Dismiss notification" @click="$emit('closeMe')">&times;</button>
      <div class="notify-alert">Live alert</div>
      <div class="notify-title">
        You just accepted {{notif.count}} house requests!
      </div>
    </div>
    <img src="https://assets.sororitywars.app/icons/notify/V2/house.png" width="40" height="40" class="notify-image" alt="" @click="$emit('closeMe')" />
  </div>
</template>

<script>
export default {
  name: 'MassAddSuccess',
  props: {
    notif: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
